import { render, staticRenderFns } from "./InsurancesList.vue?vue&type=template&id=377dd7a9&scoped=true"
import script from "./InsurancesList.vue?vue&type=script&lang=js"
export * from "./InsurancesList.vue?vue&type=script&lang=js"
import style0 from "./InsurancesList.vue?vue&type=style&index=0&id=377dd7a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377dd7a9",
  null
  
)

export default component.exports